import React from 'react'
import Swal from 'sweetalert2'
import axios from 'axios'

const DeleteProduct = (props) => {

    const deleteID = props.DelID
    const deleteName = props.DelName

    const handleProductDelete = () => {
        Swal.fire({
            title: 'Are you sure ?',
            text: `You want to delete - ${deleteName}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: 'red',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${process.env.REACT_APP_BASEURL}/products/${deleteID}`)
                    .then(res => {
                        if (res.data.status === "Success") {
                            Swal.fire(
                                'Deleted!',
                                'Product table updated!',
                                'success'
                            )
                        }
                        else {
                            Swal.fire('Error!', '', 'error')
                        }
                    })
            }
        })
    }

    return (

        <>

            <div className="delete-icon">
                <i className="bi bi-trash3 btn-sm" onClick={handleProductDelete} />
            </div>

        </>

    )
}

export default DeleteProduct
